import { render, staticRenderFns } from "./ProgramEnd.vue?vue&type=template&id=70be5a4e&scoped=true&"
import script from "./ProgramEnd.vue?vue&type=script&lang=js&"
export * from "./ProgramEnd.vue?vue&type=script&lang=js&"
import style0 from "./ProgramEnd.vue?vue&type=style&index=0&id=70be5a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be5a4e",
  null
  
)

export default component.exports